import Layout from '@/views/performance/Layout.vue';

export default {
    path: '/performance',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/performance/Summary.vue') },
        { path: 'returns', component: () => import('@/views/performance/Returns.vue') },
        { path: 'stocks-vs-nifty', component: () => import('@/views/performance/StocksVsNifty.vue') },
    ]
};
